import type { Models } from "api/types";
import { useTranslation } from "@/core/i18n";
import { DropdownSelector } from "molecules/containers/dropdown-selector/DropdownSelector";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";
import { PricingPreview } from "pages/root/shop/PackagePDP/pricing-preview/PricingPreview";
import { isBeautifiPromoEnabled } from "utils/beautifiPromo";

type BuyAgainModalProps = {
  open: boolean;
  title: string;
  price: Models<"PackagePriceModel"> | undefined | null;
  package: Models<"PackageModel"> | undefined;
  platformUserPackage: Models<"PlatformUserPackageModel">;
  platform: Models<"PlatformModel">;
  cost: number;
  isPriceSet: boolean;
  listing: Models<"ListingModel">;
  onClose: () => void;
  onClickAddToCart: () => void;
  onClickDropdownSelector: () => void;
};

export const BuyAgainModal = ({
  open,
  title,
  price,
  package: $package,
  platformUserPackage,
  platform,
  cost,
  listing,
  isPriceSet,
  onClose,
  onClickAddToCart,
  onClickDropdownSelector,
}: BuyAgainModalProps) => {
  const { t } = useTranslation();
  const unitFallback = t("buyAgainModal.unitFallback");
  const unitsFallback = t("buyAgainModal.unitsFallback");

  return (
    <ActionModal
      open={open}
      onClose={onClose}
      size="small"
      title={title}
      firstButtonLabel={t("common.addToCart")}
      onFirstButtonClick={onClickAddToCart}
      description={
        <div className="flex flex-col items-center gap-5">
          <div className="text-sub2 uppercase text-secondary">
            {t("buyAgainModal.confirmQuantity")}
          </div>
          <DropdownSelector
            text={
              price
                ? `${price?.quantity} ${
                    price?.quantity > 1
                      ? ($package?.packageUnitType.pluralUnitType ?? unitsFallback)
                      : ($package?.packageUnitType.singularUnitType ?? unitFallback)
                  }`
                : `${platformUserPackage.totalTreatmentAmount} ${
                    $package?.packageUnitType.pluralUnitType ?? unitsFallback
                  }`
            }
            state="selected"
            onClick={onClickDropdownSelector}
          />
          <div className="w-full pb-5">
            <PricingPreview
              affirmEnabled={platform.platformSettings?.affirmEnabled}
              beautifiEnabled={isBeautifiPromoEnabled(platform.platformSettings ?? undefined)}
              defaultPrice={cost}
              memberPrice={price?.membershipPrice ?? listing.membershipCost ?? undefined}
              isPriceSet={isPriceSet}
              packageUnitType={$package?.packageUnitType.singularUnitType ?? unitFallback}
            />
          </div>
        </div>
      }
    />
  );
};
